<template>
    <div @click="goBackLink">
        <slot>
            <div class="back-link">« Назад</div>
        </slot>
    </div>
</template>

<script>
    import {managePanels} from "@/lib/navigation";

    export default {
        name: "BackLink",
        methods: {
            goBackLink: function() {
                managePanels(this, null);
            },
        }
    }
</script>

<style scoped>
.back-link {
  cursor: pointer;
}
</style>